import { Component, Input } from '@angular/core'
import { coerceBooleanProperty } from '@angular/cdk/coercion'

@Component({
  selector: 'lin-layout-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  standalone: false,
})
export class SectionComponent {
  @Input() title: string
  @Input() multiline = false
  @Input()
  set scrollable(value) {
    this._scrollable = coerceBooleanProperty(value)
  }
  get scrollable() {
    return this._scrollable
  }

  private _scrollable = false
}
